export function getEnvVar(name) {
  return window?.configs?.[name] || process.env[name]
}

// This method is needed to correctly load Api Worker when serving the frontend from Apollo
export function getApiWorkerURL() {
  const cross_origin_script_url = process.env.VUE_APP_PUBLIC_PATH + "/static/js/api_worker.worker.worker.js";
  const content = `importScripts( "${ cross_origin_script_url }" );`;
  return URL.createObjectURL( new Blob( [ content ], { type: "text/javascript" } ) );
}